import { drive_file_playback_url } from './trailerPlayer';

/**
 * Normalize user input (plain video id or share URL) to the id string
 * expected by the API for Youtube and Vimeo trailers.
 * File trailers keep their URL. A convertible Drive file link is stored
 * as uc?id= so players do not force a download.
 *
 * @param {string} trailerType
 * @param {string} raw
 * @returns {string}
 */
export function normalize_new_trailer_for_api(trailerType, raw) {
    const s = raw == null ? '' : String(raw).trim();
    if (!s) {
        return s;
    }
    if (trailerType === 'youtube') {
        return extract_youtube_id(s);
    }
    if (trailerType === 'vimeo') {
        return extract_vimeo_id(s);
    }
    return drive_file_playback_url(s) || s;
}

/**
 * @param {string} raw
 * @returns {string}
 */
export function extract_youtube_id(raw) {
    const s = String(raw).trim();
    if (!s) {
        return s;
    }
    if (/^[a-zA-Z0-9_-]{11}$/.test(s)) {
        return s;
    }
    try {
        const u = /^https?:\/\//i.test(s) ? new URL(s) : new URL(`https://${s}`);
        const host = u.hostname.replace(/^www\./i, '').toLowerCase();
        if (host === 'youtu.be') {
            const id = u.pathname.split('/').filter(Boolean)[0];
            if (id && /^[a-zA-Z0-9_-]{11}$/.test(id)) {
                return id;
            }
        }
        if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'music.youtube.com') {
            const v = u.searchParams.get('v');
            if (v && /^[a-zA-Z0-9_-]{11}$/.test(v)) {
                return v;
            }
            const parts = u.pathname.split('/').filter(Boolean);
            const kind = parts[0];
            if (['embed', 'shorts', 'live'].includes(kind) && parts[1] && /^[a-zA-Z0-9_-]{11}$/.test(parts[1])) {
                return parts[1];
            }
        }
    } catch (e) {
        /* keep raw below */
    }
    return s;
}

/**
 * @param {string} raw
 * @returns {string}
 */
export function extract_vimeo_id(raw) {
    const s = String(raw).trim();
    if (!s) {
        return s;
    }
    if (/^\d+$/.test(s)) {
        return s;
    }
    const fromPath = s.match(
        /vimeo\.com\/(?:channels\/[^/]+\/|groups\/[^/]+\/videos\/|album\/\d+\/video\/|video\/|showcase\/\d+\/video\/|)(\d+)(?:\/|$|\?|#)/i
    );
    if (fromPath) {
        return fromPath[1];
    }
    const player = s.match(/player\.vimeo\.com\/video\/(\d+)/i);
    if (player) {
        return player[1];
    }
    const fallback = s.match(/vimeo\.com\/(\d+)/i);
    if (fallback) {
        return fallback[1];
    }
    return s;
}
